import React from "react";
import { StarIcon, BadgeCheckIcon } from "lucide-react";
import { Eyebrow } from "./Eyebrow";
import { metrics } from "../data/metrics";
export function Proof() {
  return <section className="w-full bg-ink px-6 py-[150px] lg:px-20" data-id="element-266" data-mp="lq2t0a13h8tv">
      <div className="mx-auto max-w-page" data-id="element-267" data-mp="lpbao0wid7lj">
        <div className="grid grid-cols-12 gap-6" data-id="element-268" data-mp="gr9jesoxi1yz">
          <div data-reveal className="col-span-12 lg:col-span-10" data-id="element-269" data-mp="grsze3v0qgad">
            <Eyebrow tone="accent" data-id="element-270" data-mp="3p61imlbnhupv">Why clients stay</Eyebrow>
            <h2 className="mt-8 text-[48px] font-semibold leading-[0.98] tracking-[-0.045em] text-white lg:text-[80px]" data-id="element-271" data-mp="3k7qbwjgnk0bv">
              Built on clarity.
              <br data-id="element-272" data-mp="2s0bshesgg6m" />
              <span className="text-white/50" data-id="element-273" data-mp="2sjkd7ijts7z">Measured by trust.</span>
            </h2>
          </div>
        </div>

        <dl data-reveal data-reveal-delay="1" className="mt-20 grid grid-cols-2 border-y border-white/[0.14] lg:grid-cols-4" data-id="element-274" data-mp="3u43237cznw1v">
          {metrics.map((m, i) => <div key={m.label} className={`flex flex-col-reverse gap-4 py-12 ${i === 0 ? "" : "lg:border-l"} ${i % 2 === 1 ? "border-l" : ""} border-white/[0.14] ${i === 0 ? "pr-8" : "px-8"}`} data-id="element-275" data-mp="31gfjtyz6xhie" data-mpi={i}>
              <dt className="text-[14px] text-white/55" data-id="element-276" data-mp="2id8wrjhqzc1k">{m.label}</dt>
              <dd className="flex items-baseline text-[60px] font-semibold leading-none tracking-[-0.045em] text-white tabular-nums" data-id="element-277" data-mp="2ig4up7tli0q0">
                {m.prefix && <span className="mr-2 text-[40px] font-light text-white/60" data-id="element-278" data-mp="1pq4tbiyaz5rw">{m.prefix}</span>}
                {m.value}
                <span className="ml-1 text-[28px] font-medium tracking-[-0.02em] text-accent" data-id="element-279" data-mp="1uopubkldpthe">
                  {m.suffix}
                </span>
              </dd>
            </div>)}
        </dl>

        <figure data-reveal className="mt-28 grid grid-cols-12 gap-6" data-id="element-280" data-mp="23q5y39houxcn">
          <span aria-hidden="true" className="col-span-12 text-[140px] font-bold leading-[0.8] text-accent lg:col-span-2" data-id="element-281" data-mp="3a456wccfb2l5">
            “
          </span>
          <div className="col-span-12 lg:col-span-9" data-id="element-282" data-mp="1f0qp2h9ci0yz">
            <blockquote className="text-[38px] font-medium leading-[1.25] tracking-[-0.025em] text-white" data-id="element-283" data-mp="1f3mo68wxivp0">
              Northgate gave us clear answers when the situation felt unnecessarily complicated. We
              always knew what was happening, what our options were, and what came next.
            </blockquote>
            <figcaption className="mt-12 flex flex-wrap items-center justify-between gap-6 border-t border-white/[0.14] pt-6" data-id="element-284" data-mp="wb0spppxp74y">
              <div data-id="element-285" data-mp="rd8s87b84cp5">
                <p className="text-[16px] font-semibold text-white" data-id="element-286" data-mp="rds8zkp50v1l">James R.</p>
                <p className="mt-1 text-[14px] text-white/50" data-id="element-287" data-mp="161viv56awqvo">Commercial Client</p>
              </div>
              <div className="flex items-center gap-4 text-[13px] text-white/50" data-id="element-288" data-mp="119ll52yy2miu">
                <span className="flex items-center gap-0.5" aria-label="Rated 5 out of 5" data-id="element-289" data-mp="dk108ej8df6x">
                  {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-accent text-accent" strokeWidth={0} data-id="element-290" data-mp="8jvflibdosyc" data-mpi={i} />)}
                </span>
                <span className="flex items-center gap-1.5" data-id="element-291" data-mp="2p0tfzrzvxsml">
                  <BadgeCheckIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-292" data-mp="2b8d9gh7rzcgx" />
                  Verified client
                </span>
              </div>
            </figcaption>
          </div>
        </figure>
      </div>
    </section>;
}